import BaseModelInstance from './base.model'
import { TermLength as ModelDefinition } from './model-definitions'

class TermLengths extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }
}

export default TermLengths
